<template>
  <facets-selection-fi
    :class="{
      'smart-recruiters-selected-filter--transparent': transparent,
    }"
    @change="$emit('click')"
  >
    <template #display>
      <template v-if="text">
        {{ text }}
      </template>
      <template v-else>
        {{
          $dict.get('smart-Recruiters.Selected-Facet', [facet?.fieldLabel, '{1}']).split('{1}')[0]
        }}
        <strong>{{ facet?.label }}</strong>
        {{
          $dict.get('smart-Recruiters.Selected-Facet', [facet?.fieldLabel, '{1}']).split('{1}')[1]
        }}
      </template>
    </template>
  </facets-selection-fi>
</template>

<script setup lang="ts">
import FacetsSelectionFiBase from '@/components/facets/facets-selection-fi/FacetsSelectionFi.vue';

defineOptions({ name: 'SmartRecruitersSelectedFilter' });

// This component only overrides the #display slot and ignores FacetsSelectionFi's
// required facet/element props, so it's cast to any to skip strict prop checking.
const FacetsSelectionFi = FacetsSelectionFiBase as any;

withDefaults(
  defineProps<{
    facet?: Record<string, any> | null;
    transparent?: boolean;
    text?: string | null;
  }>(),
  {
    facet: null,
    text: null,
  },
);

defineEmits<{
  (e: 'click'): void;
}>();
</script>

<style scoped src="./smart-recruiters-selected-filter" />
